import {Component, effect, inject} from '@angular/core';
import {
  PrecipitationSvgComponent
} from "src/app/presentation/common/icons/precipitation-svg/precipitation-svg.component";
import {
  LoadingPlaceholderComponent
} from "src/app/presentation/common/loading-placeholder/loading-placeholder.component";
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';
import {RoutingService} from 'src/app/infrastructure/routing/routing.service';

@Component({
  selector: 'app-precipitation-sample-points-button',
  imports: [
    PrecipitationSvgComponent,
    LoadingPlaceholderComponent
  ],
  templateUrl: './precipitation-sample-points-button.component.html',
  styleUrl: './precipitation-sample-points-button.component.css'
})
export class PrecipitationSamplePointsButtonComponent {

  loading: boolean = true;

  fixedSamplePointStore = inject(FixedSamplePointsStore);

  constructor(
    protected routingService: RoutingService
  ) {
    effect(() => {
      this.loading = this.fixedSamplePointStore.loading();
    });
  }
}
